import CustomContentLoader from "../ReuseableCompos/CustomContentLoader";

const LastUpdatesSkeleton = () => {
  return (
    <CustomContentLoader viewBox="0 0 400 190">
      <rect x="5" y="7" rx="4" ry="4" width="257" height="22" />
      <rect x="4" y="37" rx="4" ry="4" width="396" height="116" />
      <rect x="4" y="161" rx="4" ry="4" width="396" height="22" />
    </CustomContentLoader>
  );
};

export default LastUpdatesSkeleton;
